import makeSlice from '@web/slices/purchaser/sliceMaker'

import {initOrderSheetByAPI} from '../../actions/familyPay'
import {initFamilyPayUser} from '../../actions/familyPayUser'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                const {
                    data: {purchaser, naverMembership},
                } = payload

                state.name = purchaser.name ?? ''
                state.phoneNumber = purchaser.phoneNumber
                state.naverMembership = {
                    currentEpisode: naverMembership.currentEpisode
                        ? {
                              currentMembershipAdditionalPointPercent: naverMembership.currentEpisode
                                  .currentMembershipAdditionalPointPercent as 0 | 1 | 4,
                              familySubscribed: naverMembership.currentEpisode.familySubscribed,
                              familyTotalAcceptPurchasedAmount:
                                  naverMembership.currentEpisode.familyTotalAcceptPurchasedAmount,
                              familyTotalLevel1AcceptPurchasedAmount:
                                  naverMembership.currentEpisode.familyTotalLevel1AcceptPurchasedAmount,
                              familyTotalLevel2AcceptPurchasedAmount:
                                  naverMembership.currentEpisode.familyTotalLevel2AcceptPurchasedAmount,
                              membershipFamilyProfiles: naverMembership.currentEpisode.membershipFamilyProfiles,
                          }
                        : null,
                    membershipBenefitLayerExposed: naverMembership.membershipBenefitLayerExposed,
                    membershipPlcc: {
                        plccCardStatementExposed: naverMembership.plccCardStatementExposed ?? false,
                        plccCardTextBannerExposed: false,
                        plccExpectedPercentage: naverMembership.plccExpectedPercentage ?? 0,
                        plccMaximumAmount: 0,
                        plccPointBenefitTextBannerExposed: false,
                    },
                    subscribed: naverMembership.subscribed,
                    shouldShowQuickJoinMembershipBanner: false,
                }
            })
            .addCase(initFamilyPayUser.fulfilled, (state, {payload}) => {
                state.name = payload.name ?? ''
            })
    },
})

export default slice.reducer
